// ** Redux Imports
/* eslint-disable  */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { saleManagerManagement } from "../../../../api/Api";

export const getAllSaleManagerManagementUser = createAsyncThunk(
  "appSaleManagerManagement/getAllSaleManagerManagementUser",
  async (query) => {
    try {
      return saleManagerManagement.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllSaleManagerManagement = createAsyncThunk(
  "appSaleManagerManagement/getAllSaleManagerManagement",
  async (query) => {
    try {
      return saleManagerManagement.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getSaleManagerManagement = createAsyncThunk(
  "appSaleManagerManagement/getSaleManagerManagement",
  async (id) => {
    try {
      return saleManagerManagement.getSaleManagerManagement(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const SaleManagerManagementInList = createAsyncThunk(
  "appSaleManagerManagement/deleteSaleManagerManagement",
  async (value) => {
    return saleManagerManagement.edit(value);
  }
);

export const addSaleManagerManagement = createAsyncThunk(
  "appSaleManagerManagement/addSaleManagerManagement",
  async (value) => {
    try {
      return saleManagerManagement.create(value);
    } catch (error) {
      console.error(error);
    }
  }
);

export const deleteSaleManagerManagement = createAsyncThunk(
  "appSaleManagerManagement/deleteSaleManagerManagement",
  async (id) => {
    return saleManagerManagement.remove(id);
  }
);

export const appSaleManagerManagementSlice = createSlice({
  name: "appSaleManagerManagement",
  initialState: {
    saleManagerManagement: [],
    saleManagerManagementFetch: false,
    metaData: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllSaleManagerManagement.fulfilled, (state, action) => {
      if (action.payload?.status !== 200) {
        state.metaData = {};
        state.saleManagerManagement = [];
        state.saleManagerManagementFetch = false;
        return;
      }
      state.metaData = action.payload.data.metaData;
      state.saleManagerManagement = action.payload?.data?.data;
      state.saleManagerManagementFetch = true;
    });
  },
});

export default appSaleManagerManagementSlice.reducer;
